import { createSlice } from '@reduxjs/toolkit'
import { getInitialState } from 'store/features/recentlyUsedMedia/initialState'
import reducers from 'store/features/recentlyUsedMedia/reducers'

const recentlyUsedMediaSlice = createSlice({
  name: 'recentlyUsedMedia',
  initialState: getInitialState(),
  reducers
})

export default recentlyUsedMediaSlice
